import AlertDialog from "common/AlertDialog";
import { useEffect, useState } from "react";
import { withAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Card, CardBody } from "reactstrap";
import { showErrorMessage, showSuccessMessage } from "common/AlertContainer";
import {
  profileAddEvent,
  updateProfileCompletness,
} from "redux-helpers/ActionCreator";
import { UserStatusConstants } from "utils/Constants";
import { PractitionerService } from "utils/PractitionerService";
import { getEmptySectionShowHide, getFullAddress, makeFullNameWithAddressWhenAddressIsNested } from "utils/Utils";
import { RenderClinicalTrialsModal } from "./component/RenderClinicalTrialsModal";
import clinical_trials_icon from "assets/images/clinical-icon.png";
import NoData from "../NoData";
import CommonLoader from "common/CommonLoader";
import { useCallback } from "react";

const initialValue = {
  title: "",
  issuedBy: {},
  url: "",
  issuedOn: "",
  institutionDetail: {},
  addressLine1: "",
  addressLine2: "",
  city: [],
  country: [],
  location: [],
  postalCode: "",
  state: [],
  category: "",
};

const RenderClinicalTrials = (props) => {
  const {
    clinicalTrials,
    handleEditItem,
    handleRemoveItem,
    isLoggedinUser,
    isAdmin,
  } = props;
  const currentUser = useSelector((state) => state.auth.currentUser);
  if (clinicalTrials && clinicalTrials.length > 0) {
    return clinicalTrials.map((item, index) => {
      const institutionName = getFullAddress({
        name: item?.institutionDetail?.name ?? "",
        abbreviation: item?.institutionDetail?.abbreviation ?? "",
        location: item?.institutionDetail?.address?.location ?? "",
        city: item?.institutionDetail?.address?.city ?? "",
        state: item?.institutionDetail?.address?.state ?? "",
      });
      const issueDate = item?.issuedOn;
      const profileIdLink = item?.institutionDetail?.profileId
        ? item?.institutionDetail?.profileId
        : item?.institutionDetail?.guid;
      if (item?.institutionDetail?.guid) {
        item.institutionDetail = {
          guid: item?.institutionDetail?.guid,
          name: item?.institutionDetail?.name,
          institutionName: item?.institutionDetail ? makeFullNameWithAddressWhenAddressIsNested(item?.institutionDetail) : "",
          onSelectNewInstitutionCollege: 1,
          ...(Object.keys(item?.institutionDetail?.address).length > 0 && {
            address: item?.institutionDetail?.address,
          }),
          ...(item?.institutionDetail?.abbreviation && {
            abbreviation: item?.institutionDetail?.abbreviation,
          }),
        };
      }
      return (
        <li
          className="nex-icon-list-item"
          key={`clinicalTrials_${item.guid}`}
        >
          <div className="card-graphic">
            <img src={clinical_trials_icon} alt="" className="no-radius" style={{ width: '44px', height: '44px' }} />
          </div>
          <div className="nex-info">
            <h3 className="card-title"><a
              href={`${item.url}`}
              target="_blank"
              rel="noreferrer"
            >{item.title}</a></h3>
            <p className="card-text">
              <span className=""><svg width="18" height="18" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.48966 1.63017C7.50902 1.63444 7.52839 1.63871 7.54834 1.64312C8.58109 1.8781 9.49931 2.43784 10.1542 3.27372C10.1649 3.2872 10.1755 3.30068 10.1865 3.31456C10.9293 4.26032 11.2358 5.4686 11.0974 6.65733C10.8977 8.18356 10.0281 9.50709 9.0087 10.6199C8.99684 10.6329 8.98498 10.6459 8.97277 10.6592C8.78594 10.8636 8.59992 11.0649 8.38974 11.2458C8.33257 11.2955 8.27695 11.3468 8.22116 11.3981C7.12336 12.3858 7.12336 12.3858 6.56671 12.4284C5.85966 12.3162 5.10188 11.6105 4.61937 11.1114C4.57569 11.0678 4.53006 11.0284 4.4827 10.9888C4.34926 10.8739 4.23387 10.7421 4.11592 10.6117C4.08017 10.5724 4.04401 10.5337 4.00761 10.495C3.8366 10.3129 3.68099 10.1217 3.53018 9.92265C3.5166 9.90482 3.50301 9.887 3.48901 9.86863C2.72246 8.85969 2.04896 7.6339 2.01114 6.33671C2.01063 6.32016 2.01012 6.3036 2.0096 6.28655C1.97917 5.14098 2.33751 3.98217 3.11463 3.12275C3.15352 3.08175 3.19243 3.04076 3.23136 2.99979C3.26058 2.9657 3.28964 2.93146 3.31851 2.89707C4.30145 1.77856 6.05933 1.30936 7.48966 1.63017ZM4.92472 2.75077C4.89398 2.76605 4.86324 2.78132 4.8325 2.79659C4.52102 2.95411 4.25651 3.15819 4.00333 3.39823C3.97948 3.42048 3.95563 3.44272 3.93105 3.46564C3.22911 4.13351 2.85587 5.08901 2.82412 6.04958C2.81593 6.82337 3.06814 7.57922 3.43058 8.25419C3.44001 8.27206 3.44944 8.28992 3.45916 8.30833C3.60613 8.58595 3.7691 8.84668 3.95352 9.10087C3.97154 9.12581 3.97154 9.12581 3.98992 9.15126C4.16576 9.39352 4.35206 9.62446 4.55118 9.84794C4.56245 9.86065 4.57371 9.87335 4.58532 9.88645C4.88796 10.226 5.20542 10.5704 5.56537 10.8495C5.62085 10.893 5.67168 10.9391 5.72315 10.9872C5.83306 11.086 5.95081 11.1728 6.07022 11.2596C6.09815 11.28 6.09815 11.28 6.12665 11.3009C6.34293 11.4701 6.34293 11.4701 6.59697 11.5428C6.68246 11.511 6.75608 11.4691 6.8313 11.4183C6.8464 11.4084 6.8615 11.3984 6.87706 11.3881C7.36089 11.0642 7.79269 10.6666 8.20492 10.2576C8.24032 10.2225 8.27583 10.1875 8.31133 10.1525C8.44484 10.0192 8.56825 9.88179 8.68611 9.73444C8.72518 9.68562 8.76486 9.63794 8.80608 9.59094C9.54144 8.74885 10.1099 7.69818 10.2787 6.58573C10.2836 6.55439 10.2836 6.55439 10.2886 6.52241C10.4047 5.61122 10.1366 4.61257 9.57908 3.88156C9.52317 3.81055 9.46568 3.74101 9.40714 3.67216C9.38727 3.64876 9.3674 3.62536 9.34692 3.60124C9.23422 3.47263 9.11663 3.35641 8.9838 3.24882C8.96084 3.22991 8.93789 3.211 8.91425 3.19152C8.50398 2.8604 8.05131 2.64207 7.54724 2.49397C7.51668 2.4849 7.51668 2.4849 7.4855 2.47565C7.18564 2.39183 6.88483 2.36805 6.5745 2.36945C6.54177 2.36959 6.50905 2.36973 6.47534 2.36988C5.93252 2.37663 5.40883 2.50088 4.92472 2.75077Z" fill="black" />
                <path d="M7.57621 4.83327C7.63357 4.87589 7.68726 4.92069 7.7408 4.968C7.76131 4.98588 7.78183 5.00376 7.80296 5.02218C8.13476 5.33075 8.31318 5.75535 8.34488 6.20446C8.35966 6.70544 8.20366 7.14338 7.87339 7.52243C7.54699 7.86254 7.12158 8.05225 6.65297 8.0658C6.39337 8.069 6.16501 8.05695 5.92293 7.95628C5.89391 7.94447 5.86489 7.93265 5.83499 7.92048C5.60898 7.81829 5.44732 7.68375 5.27547 7.50804C5.25887 7.49224 5.24228 7.47645 5.22518 7.46018C4.91416 7.14284 4.79287 6.66361 4.79698 6.23354C4.82497 5.73568 5.03244 5.30179 5.39424 4.96294C5.99246 4.42999 6.91708 4.39493 7.57621 4.83327ZM5.8062 5.74376C5.66649 5.94044 5.5946 6.17113 5.6241 6.41233C5.66794 6.61509 5.72934 6.78381 5.87313 6.93528C5.8946 6.95825 5.8946 6.95825 5.91651 6.98168C6.10158 7.16099 6.31782 7.24539 6.57351 7.24812C6.86695 7.24324 7.09811 7.12064 7.30073 6.91174C7.45024 6.728 7.53022 6.49412 7.52446 6.25825C7.49933 6.03207 7.42482 5.83083 7.26766 5.66526C7.25334 5.64995 7.23902 5.63464 7.22427 5.61886C7.04232 5.44257 6.83368 5.36012 6.58129 5.35243C6.25924 5.36461 6.00824 5.49396 5.8062 5.74376Z" fill="black" />
              </svg>
              </span>
              <Link
                to={`/institution/${profileIdLink}`}
              >{" "}{institutionName}</Link></p>
            <p className="card-text text-black">{"Issued On: "}{issueDate}</p>
            <div className="nex-action">
              {(isAdmin ||
                (isLoggedinUser &&
                  currentUser.status === UserStatusConstants.APPROVED)) && (
                  <div className="delete-action">
                    <Button

                      color="link"
                      className="visible-hover py-0 nex-ct-clinical-trials-edit-btn"
                      onClick={() => handleEditItem(item)}
                    >

                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="15.9062" cy="16" r="15.375" fill="white" stroke="#DBF4FB" strokeWidth="0.75" />
                        <path d="M19.3612 9.53125L17.8557 11.0368L20.8667 14.0478L22.3722 12.5423L19.3612 9.53125ZM16.3502 12.5423L10.3281 18.5643V21.5754H13.3392L19.3612 15.5533L16.3502 12.5423Z" fill="#46ABC9" />
                      </svg>
                    </Button>
                    <Button
                      color="link"
                      className="visible-hover delete py-0 nex-ct-clinical-trials-del-btn"
                      onClick={() => handleRemoveItem(item)}
                    >
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.2266" cy="16" r="15.75" fill="#FFEAEF" />
                        <path d="M11.3984 13.7734L12.2586 20.1323C12.426 21.3702 12.5097 21.9892 12.9337 22.3597C13.3577 22.7302 13.9823 22.7302 15.2315 22.7302H18.4692C19.7184 22.7302 20.343 22.7302 20.767 22.3597C21.191 21.9892 21.2747 21.3702 21.4421 20.1323L22.3023 13.7734" stroke="#FF9191" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M14.5156 11.0475V11.0475C14.5156 10.2672 14.5156 9.87708 14.6572 9.57473C14.8061 9.25693 15.0616 9.00138 15.3794 8.85254C15.6818 8.71094 16.0719 8.71094 16.8522 8.71094V8.71094C17.6324 8.71094 18.0226 8.71094 18.3249 8.85254C18.6427 9.00138 18.8983 9.25693 19.0471 9.57473C19.1887 9.87708 19.1887 10.2672 19.1887 11.0475V11.0475" stroke="#FF9191" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M22.3023 11.0547L11.3984 11.0547" stroke="#FF9191" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M14.8906 14.1719L15.28 20.0132" stroke="#FF9191" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M18.7957 14.1719L18.4062 20.0132" stroke="#FF9191" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </Button>
                  </div>
                )}
            </div>
          </div>
        </li>
      );
    });
  }
  return "";
};

const ClinicalTrials = (props) => {
  const [pannel_on, setPannel_on] = useState(props.panelStatus);
  const currentUser = useSelector((state) => state.auth.currentUser);
  const eventName = useSelector((state) => state.profileComplete.eventName);
  const dispatch = useDispatch();
  const { guid } = props.practitioner;
  const { alert, isLoggedinUser, isAdmin, setShowTrialsOnTabScroll } = props;
  const [clinicalTrials, setClinicalTrials] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [isOpen, setModal] = useState(false);
  const toggle = () => setModal(!isOpen);
  const [isOpenAlert, setAlertModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    dispatch(updateProfileCompletness(10, !!clinicalTrials.length));

    if (clinicalTrials.length > 0 || isLoggedinUser || isAdmin) {
      setShowTrialsOnTabScroll(true);
    } else {
      setShowTrialsOnTabScroll(false);
    }

  }, [clinicalTrials]);

  useEffect(() => {
    if (eventName === "ADD_CLINICAL") {
      handleEditItem(initialValue);
      dispatch(profileAddEvent(null));
    }
  }, [eventName]);

  const toggleAlert = () => {
    setLoading(false);
    setAlertModal(!isOpenAlert);
  };

  useEffect(() => {
    if (guid && pannel_on) {
      getData();
    }
  }, [guid, pannel_on]);

  const handleEditItem = (selectedItem) => {
    setHasFetched(false);
    setSelectedItem(selectedItem);
    toggle();
  };

  const handleRemoveItem = (selectedItem) => {
    setHasFetched(false);
    setSelectedItem(selectedItem);
    toggleAlert();
  };

  const handleClickOnYes = async () => {
    setLoading(true);
    try {
      const request = PractitionerService.deleteClinicalTrial(
        guid,
        selectedItem.guid
      );
      request.then(
        (response) => {
          const { status } = response;
          if (status === 204) {
            setHasFetched(false);
            setTimeout(() => {
              showSuccessMessage("Clinical trial deleted successfully");
              getData();
              setLoading(false);
              toggleAlert();
            }, 1000);
          } else {
            showErrorMessage("Error while deleting clinical trial");
            setLoading(false);
            toggleAlert();
          }
        },
        (e) => {
          setLoading(false);
          console.log("error", e.message);
          let errmsg = e.message;
          if (e.response) {
            errmsg =
              e.response.data && !!e.response.data.message
                ? e.response.data.message
                : errmsg;
          }
          showErrorMessage(errmsg);
        }
      );
    } catch (e) {
      showErrorMessage(e.message);
      setLoading(false);
      toggleAlert();
    }
  };

  const getData = useCallback(async () => {
    if (!hasFetched) {
      setLoader(true);

      try {
        const response = await PractitionerService.getClinicalTrial(guid);
        const { data } = response;
        setClinicalTrials(data && data.length > 0 ? data : []);
        setHasFetched(true);
      } catch (error) {
        console.error("Error fetching awards:", error);
        setClinicalTrials([]);
      } finally {
        setLoader(false);
      }
    }
  }, [guid, hasFetched]);

  const globalProfileInfo = useSelector(
    (state) => state.GlobalProfileReducer.globalProfileInfo
  );

  if (
    getEmptySectionShowHide(
      clinicalTrials ?? [],
      isAdmin,
      currentUser,
      globalProfileInfo,
      guid
    )
  )
    return null;

  return (
    <>
      <Card className={`card nexogic-card-color-header ${pannel_on ? 'expanded' : ''}`} id="clinicalTrialsSection">
        <div className="card-header"><h2>Clinical Trials</h2>
          {(isAdmin ||
            (isLoggedinUser &&
              currentUser.status === UserStatusConstants.APPROVED)) && (
              <Button
                id="nex-ct-clinical-trials-add-btn"
                color="link"
                className="add-button ml-auto"
                onClick={() => handleEditItem(initialValue)}
              >
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="9.75" cy="9" r="8.4375" fill="white" stroke="#46ABC9" strokeWidth="1.125" />
                  <path d="M9.625 5.25L9.625 12.5039" stroke="#46ABC9" strokeWidth="1.125" strokeLinecap="round" />
                  <path d="M13.2656 8.88281L6.01172 8.88281" stroke="#46ABC9" strokeWidth="1.125" strokeLinecap="round" />
                </svg> Add More </Button>
            )}

          <button className="collapse-btn" type="button" onClick={() => setPannel_on(!pannel_on)}>
            <svg width={17} height={10} viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg" >
              <path
                d="M2.25 1.625L8.625 8L15 1.625"
                stroke="black"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className={`collapse-div`}>
          <CardBody className={
            clinicalTrials && clinicalTrials.length > 0
              ? ""
              : "align-items-center "
          }>
            {loader ? (
              <div className="text-center pb-5"><CommonLoader /></div>
            ) : clinicalTrials.length > 0 ? (
              <ul className="nex-icon-list-within-card" id="nex-ct-clinical-trials-lists">
                <RenderClinicalTrials
                  clinicalTrials={clinicalTrials}
                  handleEditItem={handleEditItem}
                  handleRemoveItem={handleRemoveItem}
                  isLoggedinUser={isLoggedinUser}
                  isAdmin={isAdmin}
                />
              </ul>
            ) : (
              <NoData>
                <p>No Clinical Trial Details</p>
                {clinicalTrials && clinicalTrials.length
                  ? ""
                  : (isLoggedinUser || isAdmin) &&
                  currentUser.status === UserStatusConstants.APPROVED && (
                    <Button
                      id="nex-ct-clinical-trials-add-btn2"
                      className="readmore"
                      color="link"
                      onClick={() => handleEditItem(initialValue)}
                    >
                      {"Add your Clinical Trials"}
                    </Button>
                  )}
              </NoData>
            )}
            <RenderClinicalTrialsModal
              selectedItem={selectedItem}
              toggle={toggle}
              isOpen={isOpen}
              practitionerId={guid}
              getData={getData}
              isAdmin={isAdmin}
            />
            <AlertDialog
              toggle={toggleAlert}
              isOpen={isOpenAlert}
              isLoading={isLoading}
              handleClickOnYes={handleClickOnYes}
              yesLabel={"Yes"}
              noLabel={"No"}
            />
          </CardBody>
        </div>
      </Card>
    </>
  );
};

export default withAlert()(ClinicalTrials);
